export default "__VITE_ASSET__BNC3abB7__"